
const digest = '36b9d5c1ec39485d17e26cd40bbf4acc45f366abe593b045018019f95c4bb707';
const classes = {"permittedWalks":"_permittedWalks_39tuz_1","dateCol":"_dateCol_39tuz_12","intervalsCol":"_intervalsCol_39tuz_16","inlineMultiplier":"_inlineMultiplier_39tuz_20","intervalRow":"_intervalRow_39tuz_27","buttonContainer":"_buttonContainer_39tuz_37","inline":"_inline_39tuz_20","timePicker":"_timePicker_39tuz_50"};
const css = `._permittedWalks_39tuz_1 {
  display: grid;
  grid-template-columns: 1fr 1fr;
  gap: 40px;
}

@media (max-width: 900px) {
  ._permittedWalks_39tuz_1 {
    grid-template-columns: 1fr;
  }
}
._dateCol_39tuz_12 {
  min-width: 240px;
}

._intervalsCol_39tuz_16 {
  min-width: 240px;
}

._inlineMultiplier_39tuz_20 {
  display: flex;
  flex-direction: column;
  align-items: flex-start;
  gap: 10px;
}

._intervalRow_39tuz_27 {
  width: 100%;
  display: flex;
  flex-direction: row;
  align-items: center;
  justify-content: space-between;
  gap: 10px;
  flex-wrap: nowrap;
}

._buttonContainer_39tuz_37 {
  padding-top: 15px;
}

._inline_39tuz_20 {
  display: flex;
  flex-direction: row;
  gap: 10px;
  flex-wrap: nowrap;
  flex: 1 1 auto;
  min-width: 0;
}

._timePicker_39tuz_50 {
  flex: 1 1 0;
  max-width: none;
  min-width: 0;
}`;

(function() {
  if (typeof document !== "undefined" && !document.getElementById(digest)) {
    var ele = document.createElement('style');
    ele.id = digest;
    ele.textContent = css;
    document.head.appendChild(ele);
  }
})();

export default classes;
export { css, digest, classes };
  